module.exports = __webpack_public_path__ + "static/media/teatro-partitura-1.b6669036.png";